import { number, object, string } from 'yup';
import { inventoryStatusValues } from '@/features/inventory/inventory.constants';

/**
 * `companyId` rides the create only (the update DTO does not take it), and the
 * API only honours it for a super Admin. `status` is the wire value itself,
 * as on the other Settings -> Company lists.
 */
const giftCardValueValidationSchema = object({
  companyId: string().required().label('Company ID'),
  value: number()
    .transform((value: number, raw: unknown) =>
      raw === '' || raw === null || raw === undefined || Number.isNaN(value)
        ? undefined
        : value
    )
    .typeError('Enter an amount')
    .positive('Enter an amount above 0')
    .test(
      'cents',
      'Use at most two decimals',
      value => value === undefined || Math.round(value * 100) === value * 100
    )
    .required('Enter an amount')
    .label('Value'),
  status: string().oneOf(inventoryStatusValues).default('active'),
});

export { giftCardValueValidationSchema };
